import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../App.scss';
import BTN from "../../../assets/images/btns_setting.png";
import backgroundImage from "../../../assets/images/main_background.png";
import Ribbon from "../../../assets/images/ribbon_in_black_version.png";
import AvatarHolder from "../../../assets/images/circle_wood_empty.png";
import AvatarTitle from "../../../assets/images/img_woodi.png";

class Header extends React.Component {
    constructor() {
        super();
        this.state= {
            style: {
                completed: 5,
                root: {
                    flexGrow: 1,
                    backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    width: '100%',
                    backgroundColor: "#6F0083",
                    height: '100%',
                    overflow: 'hidden'
                },
            }
        }
    }

    render() {
        const {headerText,users}=this.props.userHeader

        return(
            <Grid spacing='2' style={{marginTop:'20%',marginBottom:'10%'}} className='top-users-section' item sm={12} xs={12} alignItems='flex-end' justify={'center'} container>
                <h1 className='top-users-section-ribbon-text'>
                    {headerText}
                </h1>
                <img src={Ribbon} className='top-users-section-ribbon' alt=""/>
                <Grid style={{transform:'translateY(-50%)'}} item container sm={4} xs={4} alignItems={'center'} justify={'center'} className='top-users-section-item' >
                    <img className='top-users-section-item-avatar-holder' src={AvatarHolder} alt=""/>
                    <img className='top-users-section-item-avatar' src={users[1].avatar} alt=""/>
                    <img className='top-users-section-item-big-title' src={AvatarTitle} alt=""/>
                    <img className='top-users-section-item-small-title' src={AvatarTitle} alt=""/>
                    <p className='top-users-section-item-user-name'>
                        {users[1].name}
                    </p>
                    <p className='top-users-section-item-user-award' style={{color:'yellow'}}>
                        {users[1].award}
                    </p>
                    <p className='top-users-section-item-user-score' style={{color:'white'}}>
                        {
                            `${users[1].score}`
                        }
                    </p>
                </Grid>
                <Grid style={{alignSelf:'flex-start'}}  item container sm={4} xs={4} alignItems={'center'} justify={'center'} className='top-users-section-item' >
                    <img className='top-users-section-item-avatar-holder' style={{width:'90%'}} src={AvatarHolder} alt=""/>
                    <img className='top-users-section-item-avatar' src={users[0].avatar} alt=""/>
                    <img className='top-users-section-item-big-title' src={AvatarTitle} alt=""/>
                    <img className='top-users-section-item-small-title' src={AvatarTitle} alt=""/>
                    <p className='top-users-section-item-user-name'>
                        {users[0].name}
                    </p>
                    <p className='top-users-section-item-user-award' style={{color:'yellow'}}>
                        {users[0].award}
                    </p>
                    <p className='top-users-section-item-user-score' style={{color:'white'}}>
                        {
                           `${users[0].score}`
                        }
                    </p>
                </Grid>
                <Grid style={{transform:'translateY(-50%)'}} item container sm={4} xs={4} alignItems={'center'} justify={'center'} className='top-users-section-item'>
                    <img className='top-users-section-item-avatar-holder' src={AvatarHolder} alt=""/>
                    <img className='top-users-section-item-avatar' src={users[2].avatar} alt=""/>
                    <img className='top-users-section-item-big-title' src={AvatarTitle} alt=""/>
                    <img className='top-users-section-item-small-title' src={AvatarTitle} alt=""/>
                    <p className='top-users-section-item-user-name'>
                        {users[2].name}
                    </p>
                    <p className='top-users-section-item-user-award' style={{color:'yellow'}}>
                        {users[2].award}
                    </p>
                    <p className='top-users-section-item-user-score' style={{color:'white'}}>
                        {
                         `${users[2].score}`
                        }
                    </p>
                </Grid>
            </Grid>

        )
    }
}
export default Header